// @flow

// https://blog.callstack.io/type-checking-react-and-redux-thunk-with-flow-part-2-206ce5f6e705
type Reducer<State, Action: Object> = (State, Action) => State;
export const createReducer = <State, Action: *>(
  initialState: State,
  handlers: { [key: string]: Reducer<State, Action> },
  errorHandler?: (state: State, action: Action) => State
): Reducer<State, Action> => {
  return (state: State = initialState, action: Action): State => {
    if (action.meta && action.meta.error) {
      if (typeof errorHandler === 'function') {
        return errorHandler(state, action);
      }
      return state;
    } else {
      return handlers.hasOwnProperty(action.type)
        ? handlers[action.type](state, action)
        : state;
    }
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js